import React from 'react';
import styled from 'styled-components';

export default function MissionCardsTimerText({ style, string, className, strokeColor }) {
  return (
    <StringText strokeColor={strokeColor} theme={style} className={className}>
      {string}
    </StringText>
  );
}

const StringText = styled.div`
  ${({ theme }) => theme};
  color: #fff;
  font-weight: 800;
  -webkit-text-stroke: 1.3px ${({ strokeColor }) => strokeColor};
  text-stroke: 1.3px ${({ strokeColor }) => strokeColor};
`;

